import type { ReactNode } from 'react';
import { Text } from '@mantine/core';
import { FONT_WEIGHT_SEMIBOLD } from '@/constants/ui';

interface ConfigSectionLabelProps {
  /** Section heading text. */
  children: ReactNode;
}

/**
 * Shared heading for a map-configurator form section.
 *
 * Single source of truth for the semibold section-label look so the
 * configurator panel's sections (center, zoom, basemap) stay visually
 * consistent.
 */
export function ConfigSectionLabel({ children }: ConfigSectionLabelProps) {
  return (
    <Text fw={FONT_WEIGHT_SEMIBOLD} size="sm">
      {children}
    </Text>
  );
}
